import script from "./AiChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChat.vue?vue&type=script&setup=true&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=0d75d7eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d75d7eb"]])

export default __exports__